import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSkip"><Path d="M7.3799 4.28588C6.39225 3.57309 5 4.27107 5 5.49633V18.5036C5 19.7288 6.39225 20.4268 7.3799 19.714L16.3914 13.2104C17.2183 12.6137 17.2183 11.3862 16.3914 10.7895L7.3799 4.28588Z" fill="currentColor"/><Path d="M19 4.54038C19 4.26424 18.7761 4.04038 18.5 4.04038C18.2239 4.04038 18 4.26424 18 4.54038V19.4595C18 19.7357 18.2239 19.9595 18.5 19.9595C18.7761 19.9595 19 19.7357 19 19.4595V4.54038Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSkip;
